import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Logo from "../../assets/logo/Logo.png";

import "./Footer.css";

export default function FooterComponent() {
    return (
        <div>
            <hr/>
            <Container className="footerBackground worldwide">
                <Row>
                    <Col lg={2} style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <a href="/">
                            <img src={Logo} className="logoFooter" alt="LogoFooter"/>
                        </a>
                    </Col>
                    <Col lg={2}>
                        <p className="footerTitle">{'<'}Diverse{'/>'}</p>
                        <a href="/despre"><p className="footerLink">Despre</p></a>
                        <a href="/cv/CV Crantea Antonio-Cristian.pdf"><p className="footerLink">CV</p></a>
                        <a href="/portofoliu"><p className="footerLink">Portofoliu</p></a>
                        <a href="/blog"><p className="footerLink">Blog</p></a>
                        <a href="/contact"><p className="footerLink">Contact</p></a>
                    </Col>
                     <Col lg={3}>
                        <p className="footerTitle">{'<'}Elevi{'/>'}</p>
                        <a href="https://arhiva-info-tic.ro/" target="blank"><p className="footerLink">Arhiva Info-TIC</p></a>
                        <a href="/meditatii"><p className="footerLink">Meditații</p></a>
                        <a href="/subiecte"><p className="footerLink">Subiecte<br/>Bacalaureat</p></a>
                    </Col>
                    <Col lg={2}>
                        <p className="footerTitle">{'<'}Profesori{'/>'}</p>
                        <a href="/simulari"><p className="footerLink">Simulări</p></a>
                        <a href="/titularizare"><p className="footerLink">Titularizare</p></a>
                        <a href="/definitivat"><p className="footerLink">Definitivat</p></a>
                        <a href="/grade"><p className="footerLink">Grade</p></a>
                        <a href="/olimpiade"><p className="footerLink">Olimpiade</p></a>
                    </Col>
                    <Col lg={3}>
                        <p className="footerTitle">{'<'}Legislativ{'/>'}</p>
                        <div style={{ textAlign: "center" }}>
                            <a href="https://anpc.ro/ce-este-sal/" target="blank" rel="nofollow noopener">
                                <img decoding="async" style={{width:"250px", margin:"5px"}} src="https://layouth.ro/wp-content/uploads/resurse-publice/anpc-sal-mare.png" alt="Soluționarea Alternativă a Litigiilor" title="Soluționarea Alternativă a Litigiilor"/>
                            </a><br/>
                            <a href="https://ec.europa.eu/consumers/odr" target="blank" rel="nofollow noopener">
                                <img decoding="async" style={{width:"250px", margin:"5px"}} src="https://layouth.ro/wp-content/uploads/resurse-publice/anpc-sol-mare.png" alt="Soluționarea Online a Litigiilor" title="Soluționarea Online a Litigiilor"/>
                            </a>
                        </div>
                    </Col>
                </Row>
                <hr/>
                <Row className="align-items-center">
                    <Col xs={12} md={6} className="text-center text-md-start mb-2 mb-md-0">
                        <p className="footerSubtitle1">
                            © {new Date().getFullYear()} @info-cu-toni 💚 | Toate drepturile sunt rezervate
                        </p>
                    </Col>
                    <Col xs={12} md={6} className="text-center text-md-end">
                        <div className="d-flex justify-content-center justify-content-md-end align-items-center gap-2">
                            <p className="footerSubtitle2 mb-0">
                                <a href="/termeni">Termeni și Condiții</a>
                            </p>
                            <span className="footerSubtitle1">|</span>
                            <p className="footerSubtitle2 mb-0">
                                <a href="/confidentialitate">Politica de Confidențialitate</a>
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}